// Full named themes — each one re-skins the ENTIRE app (ground, cards, text, sidebar, accent),
// not just an accent colour. Swatch = [ground tone, accent] shown in the picker.
export const THEMES = [
  { key: 'emerald',   label: 'Emerald',    c1: '#0e3b2a', c2: '#10b981', dark: false },
  { key: 'darkblue',  label: 'Dark Blue',  c1: '#132247', c2: '#3b82f6', dark: true },
  { key: 'gold',      label: 'Gold',       c1: '#3a2e12', c2: '#e6b800', dark: false },
  { key: 'darkgrey',  label: 'Charcoal',   c1: '#232529', c2: '#c9a24b', dark: true },
  { key: 'lightgrey', label: 'Light Grey', c1: '#2b3340', c2: '#94a3b8', dark: false },
];

export function applyTheme(theme) {
  const t = THEMES.find((x) => x.key === theme) || THEMES[0];
  const r = document.documentElement;
  r.dataset.theme = t.key;
  r.style.colorScheme = t.dark ? 'dark' : 'light'; // native inputs (date/select) follow the theme
  localStorage.setItem('dfc_theme', t.key);
}

// Read the saved theme, migrating from the old {mode,accent} model if present.
export function getTheme() {
  let key = localStorage.getItem('dfc_theme');
  if (!key) {
    const mode = localStorage.getItem('dfc_mode');
    const accent = localStorage.getItem('dfc_accent');
    if (mode === 'dark') key = accent === 'navy' ? 'darkblue' : 'darkgrey';
    else if (accent === 'navy') key = 'darkblue';
    else if (accent === 'golden') key = 'gold';
    else key = 'darkgrey';
  }
  return THEMES.find((x) => x.key === key) ? key : 'darkgrey';
}

export function initTheme() { applyTheme(getTheme()); }
